import styled from 'styled-components';
import { Orientation, WriteDirection } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const StyledMobileMeasurements = styled.div<{
	orientation: Orientation;
	writeDirection: WriteDirection;
	toolsBottom: number;
}>`
	position: absolute;
	left: ${(props) => (props.writeDirection === 'rtl' ? 'auto' : '8px')};
	right: ${(props) =>
		props.writeDirection === 'rtl' && props.orientation === 'landscape'
			? '123px'
			: props.writeDirection === 'rtl'
			? '8px'
			: 'auto'};
	direction: ltr;
	white-space: pre;
	padding: 8px;
	border-radius: 4px;
	background: ${SkapaTheme.color.background.alt};
	bottom: ${(props) => (props.orientation === 'landscape' ? '16px' : props.toolsBottom + 'px')};
`;
